<template>
    <div class="page-wrapper">
      <div class="page-title">
        <CIcon name="cil-graph" /> Analytics
        <span class="page-title-badge" v-if="displacementData.length > 0">{{ displacementData.length }} entries</span>
      </div>
        <CRow>
            <CCol md="12" class="pad-r-0 pad-l-0">
                <CCard>
                    <CCardHeader>
                        <CRow>
                            <CCol sm="5">
                                <h4 id="traffic" class="card-title mb-0">Data Filters</h4>
                            </CCol>
                            <CCol sm="7" class="d-none d-md-block">
                                <CButton color="primary" class="float-right" @click="showFilter = !showFilter" >
                                    <CIcon name="cil-chevron-bottom" v-if="!showFilter"/>

                                    <CIcon name="cil-chevron-top" v-else/>
                                </CButton>
                            </CCol>
                        </CRow>
                    </CCardHeader>
                    <CCollapse
                        :show="showFilter"
                    >
                        <CCardBody>
                        
                            <CRow>
                                <CCol sm="4">
                                    <CForm>
                                        <CSelect
                                            label="Class"
                                            placeholder="Select a one"
                                            :options="options.class"
                                            :value.sync="selected.class"
                                            @change="updateFilters('family')"
                                        />      
                                    </CForm>
                                </CCol>
                                <CCol sm="4">
                                    <CForm>
                                        <CSelect
                                            label="Family Name"
                                            placeholder="Select a one"
                                            :options="options.family"
                                            :value.sync="selected.family"
                                            @change="updateFilters('group')"
                                        />        
                                    </CForm>
                                </CCol>
                                <CCol sm="4">
                                    <CForm>
                                        <CSelect
                                            label="Group Name"
                                            placeholder="Select a one"
                                            :options="options.group"
                                            :value.sync="selected.group"
                                            @change="updateFilters('identity')"
                                        />       
                                    </CForm>
                                </CCol>
                            </CRow>
                            <CRow>
                                <CCol sm="4">
                                    <CCallout color="danger">
                                        <b>Select One</b>
                                        <CInputRadioGroup
                                            name="sourceTypeRadio"
                                            :options="timeTypeRadio"
                                            :value.sync="selected.sourceType"
                                            @update:checked="updateSourceType"
                                        />
                                    </CCallout>
                                </CCol>
                                <CCol sm="4">
                                    <CForm>
                                        <CSelect
                                            label="Identity Name"
                                            placeholder="Select an one"
                                            :options="options.identity"
                                            :value.sync="selected.identity"
                                            @change="updateIdentityNames('identity')"
                                        />  
                                    </CForm>
                                </CCol>
                                <CCol sm="4">
                                    <CForm>
                                        <CSelect
                                            label="Scientific Name"
                                            placeholder="Select an one"
                                            :options="options.scientific"
                                            :value.sync="selected.scientific"
                                            @change="updateIdentityNames('scientific')"
                                        />      
                                    </CForm>
                                </CCol>
                            </CRow>
                            <CRow>
                                <CCol sm="4">
                                    <CCallout color="danger">
                                    <b>Select Time Interval</b>
                                    <CInputRadioGroup
                                        name="sourceIntervalTypeRadio"
                                        :options="timeIntervalTypeRadio"
                                        :value.sync="selected.sourceIntervalType"
                                        @update:checked="updateSourceIntervalType"
                                    />
                                    </CCallout>
                                </CCol>    
                                <CCol sm="4" v-if="selected.sourceIntervalType == 'range'">
                                    <CInput
                                        label="Select Start Date"
                                        type="date"
                                        v-model="selected.startDate"
                                    />
                                </CCol>
                                <CCol sm="4" v-if="selected.sourceIntervalType == 'range'">
                                    <CInput
                                        label="Select End Date"
                                        type="date"
                                        v-model="selected.endDate"
                                    />
                                </CCol>                        
                                <CCol sm="8" v-else-if="selected.sourceIntervalType == 'year'">
                                    <CInput
                                        label="Select any date from desired year"
                                        type="date"
                                        v-model="selected.date"
                                    />
                                </CCol>
                                
                                <CCol sm="8" v-else>
                                    <CInput
                                        label="Select any date from desired month"
                                        type="date"
                                        v-model="selected.date"
                                    />
                                </CCol>
                            </CRow>
                            <CRow>
                                <CCol sm="3">
                                    <CForm>
                                        <CSelect
                                            label="Facilities"
                                            :options="options.facilities"
                                            placeholder="Select a facility"
                                            :value.sync="selected.facility"
                                        /> 
                                    </CForm>                                
                                </CCol>
                                <CCol sm="3">
                                    <CForm>
                                        <CSelect
                                            label="Stages"
                                            :options="options.stages"
                                            placeholder="Select a stage"
                                            :value.sync="selected.stage"
                                        /> 
                                    </CForm>                                
                                </CCol>
                                <CCol sm="3">
                                    <CForm>
                                        <CSelect
                                            label="Final Outcome Wise"
                                            :options="options.outcomes"
                                            placeholder="Select an outcome"
                                            :value.sync="selected.outcome"
                                        /> 
                                    </CForm>                                
                                </CCol>
                            </CRow>
                            <CRow>
                                <CCol sm="6" class="text-center">
                                    <div style="min-height : 25px"><pulse-loader :loading="loading" color="#2E7D32"></pulse-loader></div>
                                    <CInput 
                                        placeholder="Start typing case number.."
                                        v-model="selected.caseno"
                                    >
                                        <template #prepend>
                                            <CButton color="primary" @click="apply()">
                                            <CIcon name="cil-magnifying-glass"/> Search
                                            </CButton>
                                        </template>
                                    </CInput>
                                </CCol>
                                <CCol sm="6" class="text-center">
                                    <div style="min-height : 25px"><pulse-loader :loading="loading" color="#2E7D32"></pulse-loader></div>
                                    <CInput 
                                        placeholder="Start typing place of rescue.."
                                        v-model="selected.placeOfRescue"
                                    >
                                        <template #prepend>
                                            <CButton color="primary" @click="apply()">
                                            <CIcon name="cil-magnifying-glass"/> Search
                                            </CButton>
                                        </template>
                                    </CInput>
                                </CCol>
                                <!-- <CCol sm="4">
                                    <CSelect
                                        label="Cause of Displacement"
                                        :options="options.zones"
                                        placeholder="Select a zone"
                                        :value.sync="selected.zone"
                                    />
                                </CCol> -->
                            </CRow>
                            <CRow>
                                <CCol sm="6">
                                    <label>Cause of Displacement</label>
                                    <multiselect 
                                        v-model="selected.causeOfDisp" 
                                        :options="options.causeOfDisp" 
                                        :multiple="true"
                                        :close-on-select="false"
                                    >
                                    </multiselect>
                                </CCol>
                                <CCol sm="6">
                                    <label>Zone Wise</label>
                                    <multiselect 
                                        v-model="selected.zone" 
                                        :options="options.zones" 
                                        :multiple="true"
                                        :close-on-select="false"
                                    >
                                    </multiselect>
                                    <!-- <CCol sm="3">
                                        <CSelect
                                            label="Zone Wise"
                                            :options="options.zones"
                                            placeholder="Select a zone"
                                            :value.sync="selected.zone"
                                        />
                                    </CCol> -->
                                </CCol>
                            </CRow>                        
                        </CCardBody>   

                    </CCollapse>
                    <CCardFooter class="text-center">
                        <CRow>
                            <CCol sm="4">
                                <json-excel
                                    :data = "download"
                                    :name = "filename"
                                >
                                    <CButton color="info"><CIcon name="cil-cloud-download"/> Export as excel </CButton>
                                </json-excel>
                            </CCol>
                            <CCol sm="4">
                                <CButton type="submit" color="danger" @click="reset()"><CIcon name="cil-reload"/> Reset Filters</CButton>
                            </CCol>
                            <CCol sm="4">
                                <CButton type="submit" color="primary" @click="apply()"><CIcon name="cil-check-circle"/> Apply Filters</CButton>
                            </CCol>    
                        </CRow>                                    
                    </CCardFooter>   
                </CCard>
                
            </CCol>
        </CRow>
        <CRow>            
            <CCol md="12" class="pad-r-0 pad-l-0">                
                <CCard>
                    <CCardHeader>
                        <h4 id="traffic" class="card-title mb-0">Displacement Cause Table</h4>
                        <div class="small text-danger" v-if="displacementData.length == 0">No records found for applied filters!</div>
                    </CCardHeader>
                    <CCardBody v-if="displacementData.length > 0">
                        <b-table 
                            hover
                            select-mode="single"
                            :items="displacementData"
                            :fields="displacementFields"
                            style="cursor : pointer"
                            id="displacementTable"
                        >
                            <template v-slot:cell(_id)="data">
                                <b>{{data.item._id}}</b>
                            </template>
                            <!-- <template v-slot:cell(area)="data">
                                <span v-if="data.item.area">{{data.item.area.beat}}</span>
                                <span v-else>Unknown</span>
                            </template>
                            <template v-slot:cell(datetime)="data">
                                {{data.item.datetime.substring(0,10)}} 
                            </template>
                            <template v-slot:cell(userid)="data">
                                {{data.item.userid.firstname}} {{data.item.userid.lastname}} 
                            </template> -->
                            <!-- <template v-slot:cell(action)="data">
                                
                                <CButton type="submit" size="sm" color="danger mr-4" @click="deleteSighting(data.item._id)"><small>Delete</small></CButton>
                            </template> -->
                        </b-table>

                        <!-- <area-chart 
                            id="displacementChart"
                            :data="graphs.displacement.data"
                            xkey="_id"
                            :ykeys="graphs.displacement.ykeys"
                            :labels="graphs.displacement.label"
                            :line-colors="graphColours"
                            parseTime="false"
                            grid="true"
                            ymax= 'auto'
                            grid-text-weight="bold"
                            fillOpacity="0.5"
                            resize="false">
                        </area-chart> -->
                        
                        
                    </CCardBody>
                </CCard>

            </CCol>            
        </CRow>
        <CRow>            
            <CCol md="12" class="pad-r-0 pad-l-0">                
                <CCard>
                    <CCardHeader>
                        <h4 id="traffic" class="card-title mb-0">Outcome Table</h4>
                        <div class="small text-danger" v-if="outcomeData.length == 0">No records found for applied filters!</div>
                    </CCardHeader>
                    <CCardBody v-if="outcomeData.length > 0">
                        <b-table 
                            hover
                            selectable
                            select-mode="single"
                            :items="outcomeData"
                            :fields="outcomeFields"
                            style="cursor : pointer"
                            id="outcomeTable"
                        >
                            <template v-slot:cell(_id)="data">
                                <b>{{data.item._id}}</b>
                            </template>
                        </b-table>

                        <!-- <area-chart 
                            id="outcomeChart"
                            :data="graphs.outcome.data"
                            xkey="_id"
                            :ykeys="graphs.outcome.ykeys"
                            :labels="graphs.outcome.label"
                            parseTime="false"
                            grid="true"
                            ymax= 'auto'
                            grid-text-weight="bold"
                            fillOpacity="0.5"
                            resize="false">
                        </area-chart> -->
                        
                        
                    </CCardBody>
                </CCard>

            </CCol>            
        </CRow>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import Raphael from 'raphael/raphael'
global.Raphael = Raphael
import { DonutChart, BarChart, LineChart, AreaChart } from 'vue-morris'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import axios from 'axios';
import store from '../store';
import JsonExcel from 'vue-json-excel';

export default {
    name : 'Reports',
    components: {
        Multiselect,
        PulseLoader,
        JsonExcel,
        LineChart,
        AreaChart,
        BarChart,
        DonutChart
    },
    props : {
        small : true,
        
    },
    data() {
        return {
            baseURL : store.state.baseURL,
            filename : 'SaveAnimals_Data.xls',
            showFilter : false,
            options : {
                outcomes : [],
                zones : [],
                class : [],
                group : [],
                identity : [],
                scientific : [],
                family : [],
                stages : [],
                facilities : [],
                causeOfDisp : []
            },

            graphs : {
                displacement : {
                    data : [],
                    label : [],
                    ykeys : []
                },
                outcome : {
                    data : [],
                    label : [],
                    ykeys : []
                }
            },

            selected : {
                sourceIntervalType : null,
                sourceType : null,
                date : null,
                startDate : null,
                endDate : null,
                outcome : null,
                zone : [],
                class : null,
                family : null,
                group : null,
                identity : null,
                caseno : null,
                scientific : null,
                stage : null,
                facility : null,
                placeOfRescue : null,
                causeOfDisp : []
            },
            filter : {
                fromDate : null,
                toDate : null,
                class : null,
                family : null,
                group : null,
                identity : null,
                scientific : null,
                zone : null,
                outcome : null,
                timeType : null,
                date : null,
                timeIntervalType : null,
                caseno : null,
                stage : null,
                facility : null,
                placeOfRescue : null,
                causeOfDisp : null
            },
            graphColours : [
                '#e6194B', 
                '#3cb44b', 
                '#ffe119', 
                '#4363d8', 
                '#f58231', 
                '#911eb4', 
                '#42d4f4', 
                '#f032e6', 
                '#bfef45', 
                '#808000'
            ],
            searchText : '',
            perPage: 12,
            currentPage: 1,
            loading : true,
            displacementFields : [         
            ],
            outcomeFields : [         
            ],
            download : [],

            loadPage : 1,
            pagesAvailable : 1,

            timeIntervalTypeRadio : [
                { value: 'month', label: 'Monthly Data' },
                { value: 'year',  label: 'Yearly Data' },
                { value: 'range', label: 'Date Range' },
            ],

            timeTypeRadio : [
                { value: 'outcome', label: 'Date of Outcome' },
                { value: 'admission',  label: 'Date of Admission' },
            ],

            displacementData : [],
            outcomeData : [],            
        }
    },
    beforeMount(){
        var d = new Date();
        var str = d.toISOString();
        str = str.substr(0, 10);
        str = str.replace(/-/g, '');
        this.filename = 'JungleWatch_Data_'+ str +'.xls';
    },
    created() {
        this.loading = true;
        this.selected.sourceIntervalType = 'month';  
        this.getRecords(true);
        this.getFilters();
    },
    methods: {
        updateSourceIntervalType(value, event){
            this.selected.sourceIntervalType = value;
        },
        updateSourceType(value, event){
            this.selected.sourceType = value;
        },
        apply(){
            var errors = "";
            
            if(this.selected.sourceIntervalType == 'range' && (this.selected.startDate == null && this.selected.endDate == null)){
                errors += "Date range cannot be null\n";
            }

            if(errors != "")
            {
                this.$notify({
                    group: 'notification',
                    type : 'error',
                    title: 'Important message',
                    text: errors
                });
            }
            else{
                
                this.filter = {
                    fromDate : this.selected.startDate,
                    toDate : this.selected.endDate,
                    class : this.selected.class,
                    family: this.selected.family,
                    group : this.selected.group,
                    identity : this.selected.identity,
                    scientific : this.selected.scientific,
                    zone : this.selected.zone,
                    outcome : this.selected.outcome,
                    timeType : this.selected.sourceType,
                    date : this.selected.date,
                    timeIntervalType : this.selected.sourceIntervalType,
                    caseno : this.selected.caseno,
                    stage : this.selected.stage,
                    facility : this.selected.facility,
                    placeOfRescue : this.selected.placeOfRescue,
                    causeOfDisp : this.selected.causeOfDisp
                }

                this.getRecords(true);
            }

        },
    
        
        reset(){
            this.selected = {
                sourceIntervalType : null,
                sourceType : null,
                date : null,
                startDate : null,
                endDate : null,
                outcome : null,
                zone : [],
                class : null,
                group : null,
                identity : null,
                caseno : null,
                scientific : null,
                family : null,
                stage : null,
                facility : null,
                placeOfRescue : null,
                causeOfDisp : []
            },
            this.filter = {
                fromDate : null,
                toDate : null,
                class : null,
                group : null,
                identity : null,
                zone : null,
                outcome : null,
                timeType : null,
                date : null,
                timeIntervalType : null,
                caseno : null,
                scientific : null,
                family : null,
                stage : null,
                facility : null,
                placeOfRescue : null,
                causeOfDisp : null
            }
            this.options.group = [];
            this.options.identity = [];
            this.options.family = [];
            this.options.scientific = [];
            this.searchText = '',
            
            this.getRecords(true);
        },
    
        getRecords(reset){
            this.graphs = {
                displacement : {
                    data : [],
                    label : [],
                    ykeys : []
                },
                outcome : {
                    data : [],
                    label : [],
                    ykeys : []
                }
            };
            this.getDisplacementCause();
            this.getOutcomeCause();  

        },
        getDisplacementCause(){
            this.loading = true;   
            axios({
                url : this.baseURL + "analytics/displacement-cause",
                headers : {
                    authorization : store.state.token
                },
                data : this.filter,
                method : "POST"
            })
            .then(res => {
                if(res.data.status)
                {         
                    this.displacementFields = res.data.fields;
                    this.displacementData = res.data.data;

                    this.prepareDisplacementGraph();
                    
                    this.loading = false;                    
                }
                else
                {
                    this.displacementFields = [];
                    this.displacementData = [];
                    this.$notify({
                        group   : 'notification',
                        type    : 'error',
                        title   : 'Important message',
                        text    : res.data.message
                    });
                    this.loading = false;  
                }
            })
            .catch(err => {
                this.displacementFields = [];
                this.displacementData = [];
                this.$notify({
                    group: 'notification',
                    type : 'error',
                    title: 'Important message',
                    text: err.status
                });
                this.loading = false;  
            });
        },
        getOutcomeCause(){
            this.loading = true;  
            axios({
                url : this.baseURL + "analytics/outcome-cause",
                headers : {
                    authorization : store.state.token
                },
                data : this.filter,
                method : "POST"
            })
            .then(res => {
                if(res.data.status)
                {         
                    this.outcomeFields = res.data.fields;
                    this.outcomeData = res.data.data; 
                    this.prepareOutcomeGraph();
                    this.loading = false;               
                }
                else
                {
                    this.outcomeFields = [];
                    this.outcomeData = [];
                    this.$notify({
                        group   : 'notification',
                        type    : 'error',
                        title   : 'Important message',
                        text    : res.data.message
                    });
                    this.loading = false;  
                }
            })
            .catch(err => {
                this.outcomeFields = [];
                this.outcomeData = [];
                this.$notify({
                    group: 'notification',
                    type : 'error',
                    title: 'Important message',
                    text: err.status
                });
                this.loading = false;  
            });
        },
        prepareDisplacementGraph(){



            //Set XKeys
            for( var i in this.displacementFields){
                if(this.displacementFields[i].key != '_id'){
                    this.graphs.displacement.ykeys.push(this.displacementFields[i].key);
                    this.graphs.displacement.label.push(this.displacementFields[i].label);
                }
            }

            //Set data for graph
            this.graphs.displacement.data = this.displacementData;
            this.graphs.displacement.data.pop();

            
        },
        prepareOutcomeGraph(){

            //Set XKeys
            for( var i in this.outcomeFields){
                if(this.outcomeFields[i].key != '_id'){
                    this.graphs.outcome.ykeys.push(this.outcomeFields[i].key);
                    this.graphs.outcome.label.push(this.outcomeFields[i].label);
                }
            }

            //Set data for graph
            this.graphs.outcome.data = this.outcomeData;
            this.graphs.outcome.data.pop();


            
        },
        getFilters(){
            this.loading = true;
            axios({
                url : this.baseURL + "records/filters",
                headers : {
                    authorization : store.state.token
                },
                method : "GET"
            })
            .then(res => {
                if(res.data.status)
                {                     
                    this.options.outcomes = res.data.data.outcomes;
                    this.options.facilities = res.data.data.facilities;
                    this.options.stages = res.data.data.stages;
                    this.options.class = res.data.data.classes;
                    this.options.zones = res.data.data.zones;     
                    this.options.causeOfDisp = res.data.data.displacement;      
                }
                else
                {
                    this.$notify({
                        group: 'notification',
                        type : 'error',
                        title: 'Important message',
                        text: res.data.message
                    });
                }
                this.loading = false;
            })
            .catch(err => {
                this.$notify({
                    group: 'notification',
                    type : 'error',
                    title: 'Important message',
                    text: 'Error in loading data. Something went wrong!'
                });
                console.log(err);
                this.loading = false;
                return [];
            });

        },
        updateIdentityNames(type){
            if(type == 'identity'){
                this.selected.scientific = null;
            }
            else{
                this.selected.identity = null;
            }
        },
        updateFilters(type){
            this.loading = true;
            if(type == 'family'){
                this.selected.family = null;
                this.selected.group = null;
            }
            else if(type == 'group'){
                this.selected.group = null;
            }
            axios({
                url : this.baseURL + "records/filters/animal",
                headers : {
                    authorization : store.state.token
                },
                data : {
                    class   : this.selected.class,
                    family  : this.selected.family != null ? this.selected.family : null,
                    group   : this.selected.group != null ? this.selected.group : null,
                    type    : type
                },
                method : "POST"
            })
            .then(res => {
                if(res.data.status)
                {                     
                    this.options.class      = res.data.data.class;
                    this.options.group      = res.data.data.group;
                    this.options.identity   = res.data.data.identity;   
                    this.options.family     = res.data.data.family;
                    this.options.scientific = res.data.data.scientific;        
                }
                else
                {
                    this.$notify({
                        group: 'notification',
                        type : 'error',
                        title: 'Important message',
                        text: res.data.message
                    });
                }
                this.loading = false;
            })
            .catch(err => {
                this.$notify({
                    group: 'notification',
                    type : 'error',
                    title: 'Important message',
                    text: 'Error in loading data. Something went wrong!'
                });
                console.log(err);
                this.loading = false;
                return [];
            });

        },
        onSelectRow(row){
            this.openReport(row[0]._id);

        },
        selectAnimal(item){
        },
        openReport(id){
            window.open(`/existing-case/${id}`, '_blank');
            // this.$router.push({name : 'Conflict Report', params : { surveyid }});
        }
    }
}
</script>

<style scoped>
    .pad-r-0 {
        padding-right: 0px !important;
    }
    .pad-l-0 {
        padding-left: 0px !important;
    }
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>